<template>
  <div
    class="row justify-content-center align-items-center h-100 white-base-color"
  >
    <div class="col-12 col-sm-9 col-md-8 col-lg-8 col-xl-8">
      <div class="text-center">
        <form
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="`/accept-compromise/storeCompromise`"
        >
          <img
            :src="imagesPath('images/logo_sae.png')"
            class="img-fluid d-block mx-auto"
            alt=""
          />
          <p class="text-dark my-4">
            <b>ACUERDO DE USO SISAC</b>
          </p>
          <p class="text-dark text-justify">
            En calidad de “USUARIO” del Sistema Informático de Acreditación
            SISAC, declaro que acepto y cumplo los requisitos establecidos por
            el Servicio de Acreditación Ecuatoriano SAE, para el uso de los
            medios y servicios electrónicos que provee a través del SISAC; y,
            que la documentación e información presentada y registrada es
            verídica y de mi exclusiva responsabilidad, sujetándome a los
            siguientes términos y condiciones:
          </p>
          <p class="text-dark text-justify">
            EL USUARIO garantiza la confidencialidad de toda información que
            llegue a su conocimiento por el sistema SISAC, asumiendo totalmente
            la responsabilidad administrativa, civil y penal, por la divulgación
            o mal uso de información.
          </p>
          <p class="text-dark text-justify">
            EL USUARIO, en cumplimiento de sus obligaciones con el Servicio de
            Acreditación Ecuatoriano SAE, asume totalmente la responsabilidad
            administrativa, civil y penal, tanto por la contraseña y usuario,
            que son personales e intransferibles, como por la actualidad,
            vigencia y veracidad de la información proporcionada. En tal virtud
            y en lo que corresponde al acceso y utilización del SISAC que el
            Servicio de Acreditación Ecuatoriano SAE provee, el usuario acepta
            expresamente y declara su responsabilidad, de conformidad a la Ley
            de Comercio Electrónico, Firmas Electrónicas y Mensajes de Datos,
            que su USUARIO y CONTRASEÑA utilizados en el SISAC surtirán los
            mismos efectos que una firma electrónica con una completa
            equivalencia funcional, técnica y jurídica; por lo tanto, acepta que
            todas las acciones realizadas por el usuario en el SISAC, quedan
            validadas y legalizadas con el USUARIO y CONTRASEÑA registradas.
          </p>
          <p class="text-dark text-justify">
            EL USUARIO acepta que el Servicio de Acreditación Ecuatoriano SAE,
            tiene derecho a negar, restringir o condicionar el acceso al sistema
            SISAC, de manera total o parcial, a su entera discreción; y, que el
            SAE no será responsable por pérdidas o daños sufridos en la
            información ingresada por el usuario, ya sea por fallas tecnológicas
            causadas por el mismo o por actos de terceros. Para constancia de lo
            expresado, se suscribe el presente documento.
          </p>
          <p class="text-dark text-justify">EL USUARIO</p>
          <app-input
            type="checkbox"
            :required="true"
            :list="listChecked"
            v-model="inputs.checked"
          />

          <button type="button" class="btn btn-primary my-3" @click="submit">
            ACEPTAR
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import AppFunction from "../../helpers/app/AppFunction";

export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {
        checked: [],
      },
      listChecked: [
        {
          id: "1",
          value: "Aceptar acuerdo de uso de SISAC",
        },
      ],
    };
  },
  methods: {
    imagesPath(value) {
      return AppFunction.getAppUrl(value);
    },
    submit() {
      if (this.inputs.checked.length == 0) {
        this.$toastr.e(this.$t("debe aceptar el Acuerdo para continuar"));
        return;
      }
      this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.s(this.$t("updated_success"));
      this.returnPage();
    },
    returnPage() {
      window.location.href = `/`;
    },
  },
};
</script>

<style></style>
